/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 *  A Map containing all Icons
 *
 * @file index.js
 * @author Gladson Samuel S
 * @since 0.0.1
 */

import SettingsIcon from './SettingsIcon';
import SortIcon from './SortIcon';
import DownloadIcon from './DownloadIcon';
import EmailIcon from './EmailIcon';
import EditActionIcon from './EditActionIcon';
import DeleteActionIcon from './DeleteActionIcon';
import ViewDetailsIcon from './ViewDetailsIcon';
import ProfileIcon from './ProfileIcon';
import DotIcon from './DotIcon';
import AddIcon from './AddIcon';
import BackIcon from './BackIcon';
import CaretDownIcon from './CaretDownIcon';
import CaretUpIcon from './CaretUpIcon';
import ChevronUpIcon from './ChevronUpIcon';
import CloseIcon from './CloseIcon';
import ClockIcon from './ClockIcon';
import CalendarIcon from './CalendarIcon';
import CertificateIcon from './CertificateIcon';
import BookIcon from './BookIcon';
import BrainIcon from './BrainIcon';
import FlashcardsIcon from './FlashcardsIcon';
import CaretDoublePrevIcon from './CaretDoublePrevIcon';
import CaretNextIcon from './CaretNextIcon';
import CaretDoubleNextIcon from './CaretDoubleNextIcon';
import CaretPrevIcon from './CaretPrevIcon';
import CheckboxOutlineIcon from './CheckboxOutlineIcon';
import CheckboxCheckedIcon from './CheckboxCheckedIcon';
import TickIcon from './TickIcon';
import ToastIconTick from './ToastIconTick';
import GraduationCapIcon from './GraduationCapIcon';
import MinusIcon from './MinusIcon';
import LightBulbIcon from './LightBulb';
import BugIcon from './BugIcon';
import ThreeDotMenuIcon from './ThreeDotMenuIcon';
import InfoIcon from './InfoIcon';
import OpenBookIcon from './OpenBookIcon';
import FooterInfoIcon from './FooterInfoIcon';
import CopiedIcon from './CopiedIcon';
import CopyIcon from './CopyIcon';
import TimeZoneIcon from './TimeZone';
import RedirectLinkIcon from './RedirectLinkIcon';
import AIChatBotIcon from './AIChatBotIcon';
import FlagIcon from './FlagIcon';
import MessageIcon from './MessageIcon';
import PositiveIcon from './PositiveIcon';
import NegativeIcon from './NegativeIcon';
import ExpandIcon from './ExpandIcon';
import SearchIcon from './SearchIcon';
import ChevronIcon from './ChevronIcon';
import ManageRosterIcon from './ManageRosterIcon';
import FeedbackInfoIcon from './FeedbackInfoIcon';
import FeedbackFailureIcon from './FeedbackFailureIcon';
import NoCoursesEmptyStateIcon from './NoCoursesEmptyStateIcon';
import ClipboardFileIcon from './ClipboardFileIcon';
import AddContentIcon from './AddContentIcon';
import InlineSuccessIcon from './InlineSuccessIcon';
import InlineWarningIcon from './InlineWarningIcon';
import BannerWarningIcon from './BannerWarningIcon';
import BannerCloseIcon from './BannerCloseIcon';
import TempAccessAlertIcon from './TempAccessAlertIcon';
import AlertIcon from './AlertIcon';
import EyeSlashIcon from './EyeSlashIcon';
import UploadIcon from './UploadIcon';
import CautionIcon from './CautionIcon';
import PadLockIcon from './PadLockIcon';
import DropdownCaretDownIcon from './DropdownCaretDownIcon';
import OnboardingManualSetupIcon from './OnboardingManualSetupIcon';
import OnboardingAssistedSchedulingIcon from './OnboardingAssistedSchedulingIcon';
import OnboardingAutoCreateIcon from './OnboardingAutoCreateIcon';
import OnboardingFeatureCheckIcon from './OnboardingFeatureCheckIcon';
import AddDateCalendarIcon from './AddDateCalendarIcon';
import DragHandleIcon from './DragHandleIcon';
import LinkIcon from './LinkIcon';
import CaretDownFilledIcon from './CaretDownFilledIcon';
import PlusIcon from './PlusIcon';
import ArchiveIcon from './ArchiveIcon';

const icons = new Map([
  ['SettingsIcon', SettingsIcon],
  ['SortIcon', SortIcon],
  ['DownloadIcon', DownloadIcon],
  ['EmailIcon', EmailIcon],
  ['EditActionIcon', EditActionIcon],
  ['DeleteActionIcon', DeleteActionIcon],
  ['ViewDetailsIcon', ViewDetailsIcon],
  ['ProfileIcon', ProfileIcon],
  ['DotIcon', DotIcon],
  ['AddIcon', AddIcon],
  ['BackIcon', BackIcon],
  ['CaretDownIcon', CaretDownIcon],
  ['CaretUpIcon', CaretUpIcon],
  ['ChevronUpIcon', ChevronUpIcon],
  ['CloseIcon', CloseIcon],
  ['ClockIcon', ClockIcon],
  ['CalendarIcon', CalendarIcon],
  ['CertificateIcon', CertificateIcon],
  ['BookIcon', BookIcon],
  ['BrainIcon', BrainIcon],
  ['FlashcardsIcon', FlashcardsIcon],
  ['CaretDoublePrevIcon', CaretDoublePrevIcon],
  ['CaretNextIcon', CaretNextIcon],
  ['CaretDoubleNextIcon', CaretDoubleNextIcon],
  ['CaretPrevIcon', CaretPrevIcon],
  ['CheckboxOutlineIcon', CheckboxOutlineIcon],
  ['CheckboxCheckedIcon', CheckboxCheckedIcon],
  ['TickIcon', TickIcon],
  ['ToastIconTick', ToastIconTick],
  ['GraduationCapIcon', GraduationCapIcon],
  ['MinusIcon', MinusIcon],
  ['LightBulbIcon', LightBulbIcon],
  ['BugIcon', BugIcon],
  ['ThreeDotMenuIcon', ThreeDotMenuIcon],
  ['InfoIcon', InfoIcon],
  ['OpenBookIcon', OpenBookIcon],
  ['FooterInfoIcon', FooterInfoIcon],
  ['CopiedIcon', CopiedIcon],
  ['CopyIcon', CopyIcon],
  ['TimeZoneIcon', TimeZoneIcon],
  ['RedirectLinkIcon', RedirectLinkIcon],
  ['AIChatBotIcon', AIChatBotIcon],
  ['ChevronIcon', ChevronIcon],
  ['FlagIcon', FlagIcon],
  ['MessageIcon', MessageIcon],
  ['PositiveIcon', PositiveIcon],
  ['NegativeIcon', NegativeIcon],
  ['ExpandIcon', ExpandIcon],
  ['SearchIcon', SearchIcon],
  ['ManageRosterIcon', ManageRosterIcon],
  ['FeedbackInfoIcon', FeedbackInfoIcon],
  ['FeedbackFailureIcon', FeedbackFailureIcon],
  ['NoCoursesEmptyStateIcon', NoCoursesEmptyStateIcon],
  ['ClipboardFileIcon', ClipboardFileIcon],
  ['AddContentIcon', AddContentIcon],
  ['InlineSuccessIcon', InlineSuccessIcon],
  ['InlineWarningIcon', InlineWarningIcon],
  ['BannerWarningIcon', BannerWarningIcon],
  ['BannerCloseIcon', BannerCloseIcon],
  ['TempAccessAlertIcon', TempAccessAlertIcon],
  ['AlertIcon', AlertIcon],
  ['EyeSlashIcon', EyeSlashIcon],
  ['UploadIcon', UploadIcon],
  ['CautionIcon', CautionIcon],
  ['PadLockIcon', PadLockIcon],
  ['DropdownCaretDownIcon', DropdownCaretDownIcon],
  ['OnboardingManualSetupIcon', OnboardingManualSetupIcon],
  ['OnboardingAssistedSchedulingIcon', OnboardingAssistedSchedulingIcon],
  ['OnboardingAutoCreateIcon', OnboardingAutoCreateIcon],
  ['OnboardingFeatureCheckIcon', OnboardingFeatureCheckIcon],
  ['AddDateCalendarIcon', AddDateCalendarIcon],
  ['DragHandleIcon', DragHandleIcon],
  ['LinkIcon', LinkIcon],
  ['CaretDownFilledIcon', CaretDownFilledIcon],
  ['PlusIcon', PlusIcon],
  ['ArchiveIcon', ArchiveIcon]
]);

export default icons;

